if (!customElements.get('custom-gift-wrapping')) {
  customElements.define(
    'custom-gift-wrapping',

    class CustomGiftWrapping extends HTMLElement {
      onCartUpdateUnsubscriber = undefined;
      cart = undefined;
      checkbox = undefined;
      fieldTo = undefined;
      fieldFrom = undefined;
      fieldNote = undefined;

      constructor() {
        super();
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.checkbox = this.querySelector(".gift-wrapping__checkbox_input");
        this.fieldTo = this.querySelector(".gift-wrapping__form_to");
        this.fieldFrom = this.querySelector(".gift-wrapping__form_from");
        this.fieldNote = this.querySelector(".gift-wrapping__form_note");
      }

      connectedCallback() {
        this.onCartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          this.cartUpdated.bind(this)
        );
      }

      disconnectedCallback() {
        this.onCartUpdateUnsubscriber();
      }

      cartUpdated({ source, productVariantId, cartData }) {
        // Only react to add-to-cart events from product form, not from cart items
        if (source !== "product-form") return;

        // Only add wrapping if checked
        if (!this.checkbox.checked) return;

        // Product to wrap
        const productTitle = cartData.title;

        // Assemble the gift wrapping line item
        var giftWrappingVariantId = this.dataset.giftWrappingVariantId;
        var giftWrappingItem = {
          'id': giftWrappingVariantId, 
          'quantity': 1,
          'properties': {
            'Item': productTitle,
            'To': this.fieldTo.value,
            'From': this.fieldFrom.value,
            'Note': this.fieldNote.value
          }
        };

        // Add sections for re-rendering the cart
        if (this.cart) {
          giftWrappingItem['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
          giftWrappingItem['sections_url'] = window.location.pathname;
        }

        // Add the product to cart and re-render the cart from the response
        fetch('/cart/add.js', {
          body: JSON.stringify(giftWrappingItem),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With':'XMLHttpRequest' 
          },
          method: 'POST'
        })
        .then(response => response.json())
        .then(response => {
          if (this.cart) this.cart.renderContents(response);
        });

      }


    }

  );
}
